import { useObserver } from "mobx-react";
import { useStores } from "../../../store";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useEffect } from "react";

export default function Remainder(props) {
  const { PopupStore, RecuiterStore } = useStores();
  useEffect(() => {
    RecuiterStore.RemaindedAssessment = [];
  }, [ ]);
  return useObserver(() => (
    
    <>
      {PopupStore.Remainder && (
        <div
          onClick={() => {
            
            PopupStore.setRemainder(false);
          }}
          className="fixed w-screen h-screen z-40 inset-0 backdrop-filter backdrop-blur-sm bg-black/30"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="absolute inset-0 bg-white z-50 flex flex-col justify-center rounded-2xl items-center md:h-[30vh] md:w-[25vw] lg:w-[20%] w-[90%] h-fit m-auto shadow-xl overflow-y-auto no-scrollbar"
          >
            <AiOutlineCloseCircle
              className="w-6 h-6 text-gray-400 hover:text-gray-600 cursor-pointer absolute top-4 right-4 transition-colors"
              onClick={() => {

                PopupStore.setRemainder(false);
              }}
            />
            <div className="flex flex-col w-full h-full justify-center items-start p-8">
              <h2 className="text-2xl font-medium text-gray-800 mb-6">Remind about</h2>
              <div className="w-full space-y-3">
                {props?.options?.map((option) => (
                  <label key={option.name} className="flex items-center space-x-3 cursor-pointer group">
                    <input
                      type="checkbox"
                      id={option.name}
                      name={option.name}
                      value={option.name}
                      onChange={(e) => {
                        if (e.target.checked) {
                          RecuiterStore.RemaindedAssessment.push(option);
                        } else {
                          RecuiterStore.RemaindedAssessment =
                            RecuiterStore.RemaindedAssessment.filter(
                              (item) => item.name !== option.name
                            );
                        }
                      }}
                      className="w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary"
                    />
                    <span className="text-gray-700 group-hover:text-gray-900 transition-colors">{option.name}</span>
                  </label>
                ))}
              </div>
              <div className="flex w-full justify-end mt-8">
                <button
                  className={`px-6 py-2 rounded-lg text-white font-medium transition-all ${
                    RecuiterStore.RemaindedAssessment.length < 1
                      ? "bg-gray-300 cursor-not-allowed"
                      : "bg-primary hover:bg-primary/90"
                  }`}
                  disabled={RecuiterStore.RemaindedAssessment.length < 1}
                  onClick={() => {
                    if (RecuiterStore.RemaindedAssessment.length < 1) {
                      return;
                    }
                    props.onSent();
                    PopupStore.setRemainder(false);
                  }}
                >
                  Done
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  ));
}
